import { getCookie } from './fn';

export function loadMstv(wrapper, edtn, isMstv, isAutoPlay, isYoutube) {
  const abtestCookie = getCookie('abtest');
  console.log(isYoutube, abtestCookie);

  if (isAutoPlay || (isMstv && (edtn == 'de' || edtn == 'ev_de'))) {
    appendIframe(wrapper.dataset.videoUrl);
  } else {
    wrapper.addEventListener('click', (event) => {
      appendIframe(wrapper.dataset.videoUrl);
    });
  }

  if (edtn == 'it') {
    const ordinaryButton = wrapper.querySelector('.play-button__ordinary');
    const youtubeButton = wrapper.querySelector('.play-button__youtube');
    if (
      isYoutube &&
      (abtestCookie == 'Auto-v1.2' || abtestCookie == 'Auto-v1.1')
    ) {
      ordinaryButton.remove();
      youtubeButton.style.visibility = 'visible';
    } else {
      youtubeButton.remove();
      ordinaryButton.style.visibility = 'visible';
    }
  }

  function appendIframe(url) {
    let iframe = document.createElement('iframe');
    iframe.setAttribute('allow', 'autoplay');
    iframe.setAttribute('allowfullscreen', 'allowfullscrean');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('src', url);
    wrapper.appendChild(iframe);
  }
}
